let customAnimatedScroll = {
  _btn : 'customScrollBrand',
  _target: '.homepage-map--fallback-wrap',
  
  ScrollToTarget: function() {
    let btnClick = document.getElementById(this._btn);
    let targetWrapper = document.querySelector(this._target);

    if (!btnClick || !targetWrapper) return;

    btnClick.addEventListener('click', function() {
      targetWrapper.scrollIntoView({
        behavior: 'smooth',
        block: 'end'
      });
    });
  }
}

customAnimatedScroll.ScrollToTarget();